module.exports = __webpack_public_path__ + "img/AndroidBack.f3d8b80a.jpg";